const data = {
  chiapas: [
    {
      id: 1,
      text: 'Quintana Roo',
      url: 'https://quintanaroo.turista.com.mx',
    },
    {
      id: 2,
      text: 'Yucatán',
      url: 'https://yucatan.turista.com.mx',
    },
    {
      id: 3,
      text: 'Puebla',
      url: 'https://puebla.turista.com.mx',
    },
    {
      id: 4,
      text: 'Edomex',
      url: 'https://edomexico.turista.com.mx',
    },
    {
      id: 5,
      text: 'México',
      url: 'https://turista.com.mx',
    },
    {
      id: 6,
      text: 'USA',
      url: 'https://usa.turista.com.mx',
    },
  ],
  yucatan: [
    {
      id: 1,
      text: 'Quintana Roo',
      url: 'https://quintanaroo.turista.com.mx',
    },
    {
      id: 2,
      text: 'Chiapas',
      url: 'https://chiapas.turista.com.mx',
    },
    {
      id: 3,
      text: 'Puebla',
      url: 'https://puebla.turista.com.mx',
    },
    {
      id: 4,
      text: 'Edomex',
      url: 'https://edomexico.turista.com.mx',
    },
    {
      id: 5,
      text: 'México',
      url: 'https://turista.com.mx',
    },
    {
      id: 6,
      text: 'USA',
      url: 'https://usa.turista.com.mx',
    },
  ],
  edomexico: [
    {
      id: 1,
      text: 'Puebla',
      url: 'https://puebla.turista.com.mx',
    },
    {
      id: 2,
      text: 'Chiapas',
      url: 'https://chiapas.turista.com.mx',
    },
    {
      id: 3,
      text: 'Quintana Roo',
      url: 'https://quintanaroo.turista.com.mx',
    },
    {
      id: 4,
      text: 'Yucatán',
      url: 'https://yucatan.turista.com.mx',
    },

    {
      id: 5,
      text: 'México',
      url: 'https://turista.com.mx',
    },
    {
      id: 6,
      text: 'USA',
      url: 'https://usa.turista.com.mx',
    },
  ],
}

export default data
